export const generateFolderTimestamp = () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = String(now.getFullYear()).slice(-2);
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${day}-${month}-${year}-${hours}${minutes}`;
};

export const generateSplitFolderName = (file) => {
  const sanitizedFileName = file?.name?.replace(/[/\\:*?"<>|]/g, ' ') || 'split';
  return `${sanitizedFileName}-split-${generateFolderTimestamp()}`;
};

export const generateRemovePagesFolderName = (file) => {
  const sanitizedFileName = file?.name?.replace(/[/\\:*?"<>|]/g, ' ') || 'remove-pages';
  return `${sanitizedFileName}-remove-pages-${generateFolderTimestamp()}`;
};
